<template>
	<el-main class="center-wrap pointwrap">
		<div class="pointbox">
			<div class="card-header">
				<div>
					<div class="card-title">我的积分</div>
					<div class="card-desc">查看积分余额与兑换记录</div>
				</div>
			</div>
			<el-row class="cinfo-box flexBetween">
				<el-col :span="16">
					<div class="mypoint">
						当前可用：<strong class="point">8376<i>积分</i></strong>
					</div>
					<div class="mypoint-notice">积分可兑换商品，100个积分可抵1元现金</div>
				</el-col>
				<el-col :span="8" style="text-align: right">
					<button class="btn btn-primary is-round" type="button">
						<span>立即去兑换</span>
					</button>
				</el-col>
			</el-row>
		</div>
		<div class="logbox">
			<h3>收支明细</h3>
			<div class="tabtit">
				<el-link :underline="false" class="is-sel" href="javascript:void(0);" type="primary">全部</el-link>
				<el-link :underline="false" href="javascript:void(0);">已获取</el-link>
				<el-link :underline="false" href="javascript:void(0);">已消耗</el-link>
			</div>
			<div class="loglist">
				<el-table :data="loglist" stripe style="width: 100%">
					<el-table-column label="积分变更说明" prop="logtxt"></el-table-column>
					<el-table-column label="变更时间" prop="addtime" width="180"></el-table-column>
					<el-table-column label="变更数量" prop="point" width="100"></el-table-column>
				</el-table>
			</div>
			<div class="pagebox">
				<el-pagination :page-size="pageSize" :total="allNum" background layout="total, sizes, prev,  next"> </el-pagination>
			</div>
		</div>
	</el-main>
</template>

<script>
	import Y from '@/utils/Y';
	import PointLogList from './data/PointLogList';
	import { getMemberGetIntegral } from '@/api/user/point';

	export default {
		data() {
			return {
				loglist: PointLogList,
				pageSize: 20,
				allNum: 400
			};
		},
		components: {},
		methods: {
			async getMemberGetIntegral() {
				const res = getMemberGetIntegral();
			},

			// 加载订单量折线图
			load() {},

			// 编辑收货地址
			openInfo(sid) {
				Y.alert('添加/编辑 收货地址');
			},

			// 删除收货地址
			removeInfo(sid) {
				Y.confirm('确认删除此单位信息吗？').then(rlt => {
					if (rlt.confirm) {
						Y.msg.success('数据删除成功！');
					}
				});
			},

			setDefault(sid) {
				Y.confirm('确认修改默认付款单位吗？').then(rlt => {
					if (rlt.confirm) {
						Y.msg.success('恭喜！修改成功');
					}
				});
			}
		},

		// 加载完执行
		created() {
			// this.load();
			this.getMemberGetIntegral();
		}
	};
</script>

<style lang="less" scoped>
	.pointbox {
		margin: -30px -40px 40px;
		padding: 30px 40px;
		background: url(@/assets/images/pointwrap-bg.jpg) no-repeat center center;
		background-size: cover;
	}
	.cinfo-box {
		padding: 20px 20px 10px;
		strong {
			font-size: 36px;
			font-weight: 400;
			color: #155dfc;
		}
		i {
			margin-left: 5px;
			font-size: 14px;
			font-style: normal;
		}
		.mypoint-notice {
			margin-top: 10px;
			font-size: 14px;
			color: #94a3b8;
		}
	}
	.tabtit {
		margin: 20px 0 15px;
		font-size: 16px;
		color: #475569;
	}
	.el-link {
		display: inline-block;
		margin-left: 0;
		padding-right: 20px;
		font-size: 16px;
		color: #475569;
	}
	.el-link:after {
		content: '';
		padding-left: 20px;
		border-right: 1px solid #e2e8f0;
	}
	.el-link:last-child::after {
		border-right: 1px solid transparent;
	}
	.el-link.el-link--primary {
		color: #155dfc;
	}
	.loglist {
		background-color: #ffffff;
		border-radius: 2px;
		border: 1px solid #bfdbfe;
	}
	/deep/ .el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px dashed #e2e8f0;
	}
	/deep/ .el-table th.el-table__cell {
		background-color: #eff6ff;
		font-weight: 400;
		color: #334155;
	}
	.pagebox {
		margin-top: 20px;
	}
	//媒体查询-pad
	@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		.btn-primary {
			font-size: 16px;
		}
		/deep/ .el-pagination {
			> span {
				display: none;
			}
		}
		.pointbox {
			margin: -30px -20px 40px;
			padding: 20px;
		}
		.cinfo-box {
			padding: 20px 0px 10px;
		}
	}

	.card-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 24px;
		padding-bottom: 20px;
		border-bottom: 1px dashed #e2e8f0;
	}
	.card-title {
		font-size: 18px;
		font-weight: 700;
		color: #0f172a;
		margin-bottom: 4px;
	}
	.card-desc {
		font-size: 13px;
		color: #94a3b8;
		line-height: 1.6;
	}
</style>
